import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from '../../../../common/api/request';

export interface No3Cn56BilateralRequest {
  sendingPpo: string;
  receivingPpo: string;
  year: number;
  accountingType: string;
  mailCategoryEnum: string;
  rowType: string;
  cn56ItemsOriginal: string;
  cn56WeightOriginal: string;
  no3IpkOriginal: string;
  no3GrossIpkOriginal: string;
  cn56Items: string;
  cn56Weight: string;
  no3Ipk: string;
  no3Adj: string;
  no3GrossIpk: string;
  no3NetP: string;
  no3NetG: string;
  no3NetE: string;
}

interface UseNo3Cn56BilateralMutationOptions {
  onSuccess?: (data: any) => void;
  onError?: (error: any) => void;
}

/**
 * Hook for updating NO3 & CN56 bilateral data
 * 
 * @param options Success and error callback options
 * @returns Mutation hook for updating bilateral data
 */
export const useNo3Cn56BilateralMutation = (options?: UseNo3Cn56BilateralMutationOptions) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (bilateralData: No3Cn56BilateralRequest) => {
      console.log('Making API request to /no3-cn56-bilateral');
      console.log('Payload:', JSON.stringify(bilateralData, null, 2));
      
      const response = await axios.post('/no3-cn56-bilateral', bilateralData, {
        headers: {
          'Content-Type': 'application/json',
        }
      });
      
      console.log('API Response:', response);
      return response.data;
    },
    onSuccess: (data, variables) => {
      // Invalidate relevant queries to refetch the updated data
      queryClient.invalidateQueries({ 
        queryKey: ['no3-cn56-summary'] 
      });
      
      // Call the provided success callback
      options?.onSuccess?.(data);
    },
    onError: (error: any) => {
      console.error('API Error Details:', error);
      if (error?.response) {
        console.error('Error Response:', error.response);
        console.error('Error Data:', error.response.data);
        console.error('Error Status:', error.response.status);
        console.error('Error Headers:', error.response.headers);
      }
      
      // Call the provided error callback
      options?.onError?.(error);
    }
  });
};